export const formatPrice = (amount) => `${String(amount).replace(".", ",")} kr`;

export const formatReceiptNumber = (receiptNumber) => String(receiptNumber);

export const formatSaleDate = (saleDate) =>
  saleDate.replace("T", " ").slice(0, 16);
